import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { initializeForm } from '../../../utils/form';
import { ADDITIONAL_PARTICIPANT_EVENTS } from '../../../event_bus_modules/additional_participant';
import { validateEmail, validateNotEmpty, validateValueNotTaken } from '../../../utils/validators';

$(() => {
  const directorFormCheckBox = $('#checkbox-no-director');
  const directorFormContainer = $('#director-container');
  const directorFormHeader = $("p[name='director-container-header']");
  const formIsRequired = directorFormHeader.hasClass('required');
  const primaryPurchaserEmail = $('input#_primary_purchaser_email').val();

  if (directorFormCheckBox.val() === 'myself') {
    directorFormCheckBox.prop('checked', true);
  }

  const onDirectorCheckboxChange = () => {
    directorFormContainer.toggleClass('d-none');

    if (directorFormCheckBox.prop('checked')) {
      directorFormContainer
        .find("input:not([name='submit'], [name='csrfmiddlewaretoken'])")
        .val('')
        .trigger('change')
        .trigger('clearSelect');
      directorFormCheckBox.val('myself');
      directorForm.restart();
      if (formIsRequired) {
        EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.DIRECTOR,
        });
      }
    } else {
      directorFormCheckBox.val('additional-director');
      if (formIsRequired) {
        EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.ADD_ERROR, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.DIRECTOR,
        });
        directorForm.restart();
      }
    }
  };
  if (directorFormCheckBox.prop('checked')) {
    directorFormContainer.toggleClass('d-none');
    directorFormCheckBox.val('myself');
  }
  const directorForm = initializeForm(directorFormContainer, {
    preventDefault: true,
    validate: (values) => {
      let addedDirectorsNumber = directorFormContainer.find(
        '.additional-participant__added-person-row'
      ).length;

      const errors = {
        ...validateEmail(values, 'email'),
        ...validateNotEmpty(values, ['first-name', 'last-name']),
        ...validateValueNotTaken(values, 'email', {
          valuesTaken: [primaryPurchaserEmail],
        }),
      };

      let hasErrors = false;
      if (!directorFormCheckBox.prop('checked') && formIsRequired) {
        hasErrors = addedDirectorsNumber == 0 ? true : false;
      }

      const eventType = hasErrors
        ? ADDITIONAL_DETAILS_EVENTS.ADD_ERROR
        : ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR;

      EVENT_BUS.dispatch(eventType, {
        error: ADDITIONAL_DETAILS_EVENTS.ERROR.DIRECTOR,
      });

      return errors;
    },
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_NEW_PARTICIPANT, () => {
    if (directorForm) {
      directorForm.restart();
    }
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.REMOVED_PARTICIPANT, () => {
    if (directorForm) {
      directorForm.restart();
    }
  });

  EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_SELECTED_PARTICIPANT, () => {
    if (directorForm) {
      directorForm.restart();
    }
  });

  directorFormCheckBox.on('change', onDirectorCheckboxChange);
});
